import { ICountryAssetLite } from "models/Assets/ICountryAsset";
import { ICategoryAsset } from "models/Assets/ICategoryAsset";
import { AllowedCitiesTypes } from "contexts/AssetsContext";
import { INeighborhoodLiteAsset } from "models/Assets/INeighborhoodAsset";
import {
  ICpOption,
  IDynamicAttributeEnhanced,
  IDynamicRangeAttributes,
} from "models/Assets/IDynamicAttributes";
import { filterCurrencyByCurrencyId } from "dataLayer/filters/filterCountryByCountryCode";
import {
  filterMainCategoryByCatId,
} from "dataLayer/filters/categories";
import {
  filterCityByCityId,
  filterNeighborhoodByNeighborhoodId,
  filterNeighborhoodFromCitiesByNeighborhoodId,
} from "dataLayer/filters/citiesAndHoods";
import { ICityLiteAsset } from "models/Assets/ICityAsset";
import {
  filterCPOptionByOptionIdAndFieldName,
  filterDynamicAttributesByFieldName,
} from "dataLayer/filters/filterDynamicAttributes";
import {
  DynamicRangeAttributeQueryString,
  IRouteObjects,
  IRouteObjectsIds,
} from "contexts/RoutesObjectContext";

export const parseRouteObjectByIds = (
  country: ICountryAssetLite,
  categories: ICategoryAsset[],
  subCategories: ICategoryAsset[] = null,
  cities: AllowedCitiesTypes[],
  neighborhoodsAssets: INeighborhoodLiteAsset[],
  dynamicAttributesEnhanced: IDynamicAttributeEnhanced[],
  routeObjects: IRouteObjects,
  routeObjectsIds: IRouteObjectsIds
) => {
  const currency =
    routeObjects?.currency ||
    filterCurrencyByCurrencyId(
      country,
      routeObjectsIds?.currencyId ?? country?.default_currency
    );

  const category =
    routeObjects?.category ||
    filterMainCategoryByCatId(categories, routeObjectsIds?.categoryId);

  const subCategory =
    routeObjects?.subCategory ||
    filterMainCategoryByCatId(
      subCategories || category?.subCategories || [],
      routeObjectsIds?.subCategoryId
    );

  const city =
    routeObjects?.city ||
    filterCityByCityId<ICityLiteAsset>(cities, routeObjectsIds?.cityId);
  const neighborhoods =
    routeObjects?.neighborhoods && routeObjects?.neighborhoods.length > 0
      ? routeObjects?.neighborhoods
      : (routeObjectsIds?.neighborhoodIds || []).map((nHoodId) => {
          if (neighborhoodsAssets) {
            return filterNeighborhoodByNeighborhoodId<INeighborhoodLiteAsset>(
              neighborhoodsAssets,
              nHoodId
            );
          } else {
            return filterNeighborhoodFromCitiesByNeighborhoodId(
              cities,
              nHoodId
            );
          }
        });

  //Inputs
  const { dynamicAttributes } = routeObjectsIds || {};
  //Outputs:

  // Range Fields Processing
  const applyRangeData = (attr: IDynamicAttributeEnhanced) => {
    const data = dynamicAttributes as DynamicRangeAttributeQueryString;
    const {
      unit: unitId = null,
      from = null,
      to = null,
    } = data[attr.fieldName];
    const [unit = null] = (attr?.field?.units || []).filter(
      (u) => u.id === Number(unitId)
    );
    dynamicRangeAttributes[attr.fieldName] = {
      from,
      to,
      unit,
    };
  };

  const applyRangeDataForCar_Year = (
    attr: IDynamicAttributeEnhanced,
    optionId: number
  ) => {
    if (
      dynamicRangeAttributes?.Car_Year?.from ||
      dynamicRangeAttributes?.Car_Year?.to
    )
      return;
    if (!optionId) return;
    const carYearOption = attr.options.find(
      (o) => o.id === optionId || o.value == optionId
    );
    dynamicRangeAttributes["Car_Year"] = {
      from: Number(carYearOption.value),
      to: Number(carYearOption.value),
    };
  };

  const dynamicRangeAttributes = {} as IDynamicRangeAttributes;
  let selectedCpsOptions: ICpOption[] = [];
  if (dynamicAttributes && Object.keys(dynamicAttributes).length > 0) {
    Object.keys(dynamicAttributes).forEach((fieldName) => {
      const attr = filterDynamicAttributesByFieldName(
        dynamicAttributesEnhanced,
        fieldName
      );
      if (
        !Array.isArray(dynamicAttributes[fieldName]) &&
        (attr?.field?.type === "text" || attr?.fieldName === "Car_Year")
      ) {
        applyRangeData(attr);
      } else if (!attr || attr.field.type === "dropdownlist") {
        let optionIds = dynamicAttributes[fieldName] as number[];
        if (typeof optionIds === "object") {
          optionIds = Object.keys(optionIds).map((k) => optionIds[k]);
        }
        selectedCpsOptions = selectedCpsOptions
          .concat(
            optionIds.map((optionId) =>
              filterCPOptionByOptionIdAndFieldName(
                dynamicAttributesEnhanced,
                attr,
                optionId
              )
            )
          )
          .filter(Boolean);
        if (attr?.fieldName === "Car_Year") {
          applyRangeDataForCar_Year(attr, Number(optionIds[0]));
        }
      }
    });
  }

  return {
    city,
    neighborhoods,
    category,
    subCategory,
    selectedCpsOptions,
    dynamicRangeAttributes:
      Object.keys(dynamicRangeAttributes).length > 0
        ? dynamicRangeAttributes
        : routeObjects?.dynamicRangeAttributes || {},
    currency,
  };
};
